/**
 * Website Analytics — every sentence on the page, PURE so each is asserted
 * without jsdom (the `pullFreshnessMessage` precedent).
 *
 * ⚠️⚠️ WHAT THE NUMBERS MEAN IS STATED ON THE PAGE, NOT IN A COMMENT (brief
 * 2026-09-27). The measured shape, 2025-08-01..2026-09-27: about a fifth of the
 * site's sessions touched no studio page (20.5%), and a session viewing two
 * studios counts for both (0.9%). So per-studio figures do not sum to the site.
 *
 * ⚠️⚠️ NOTHING HERE PHRASES A STUDIO AS A PERCENTAGE OF THE SITE, at either
 * scope. The two errors pull opposite ways, so a wrong share looks plausible.
 * ⚠️ AND DO NOT RESTORE THE "UNMEASURABLE" WORDING for the double-count — it was
 * measured, it is small, and an overstated warning gets dismissed along with the
 * true part.
 */

import type { PortalWebsiteReport } from '../../types/portalWebsite.js';

/** What a studio's sessions are. Both scopes. */
export const STUDIO_SESSION_MEANING =
  "A studio's visits are the visits in which someone looked at that studio's pages — including people who arrived on the home page and browsed into it.";

/** Why the studios don't add up to the site. Brand only (a studio login sees no site total). */
export const SITE_VS_STUDIOS =
  "About a fifth of visitors to the site never open a studio page, so they are in the site's total and in no studio's. And a visit that looks at two studios counts for both — about 1 in 100 visits. So the studios' figures don't add up to the site's, and aren't shares of it.";

/** New users, and where the per-studio figure comes from. */
export function newUsersNote(basis: PortalWebsiteReport['headline']['newUsersBasis']): string {
  return basis === 'landed-on-studio'
    ? "New users here are first-time visitors whose first page on the site was one of this studio's."
    : 'New users are first-time visitors to the site.';
}

/** ⚠️ Checked against the data 2026-09-27: `city` is a town or city, and IP-located. */
export const PLACES_NOTE =
  "Worked out from each visitor's internet connection, so it's approximate — someone in a smaller town often shows as the nearest city.";

export const KEY_EVENTS_NOTE =
  'The actions the website records, and how many times each was recorded. Shown as recorded — not a conversion rate, and not comparable with the Meta or Google results.';

export function notKyckManagedNote(): string {
  return 'Studios marked "not managed by Kyck" appear here because they are on your website; Kyck does not run their advertising.';
}

/** The eyebrow over the headline. */
export function websiteEyebrow(studioLabel: string | null): string {
  return studioLabel ? `${studioLabel} · website` : 'All studios · website';
}
